<template>
  <v-list-item
    v-if="!appNavigation?.isItemHidden(route) && isRoutePermitted"
    v-bind="activatorProps"
    color="primary"
    :exact="route.meta?.exact"
    :title="route.meta?.title?.value"
    :to="route.name ? { name: route.name } : undefined"
  >
    <template v-if="icon" #prepend>
      <v-icon class="icon opacity-100" :icon :size="18" />
    </template>

    <template v-if="activatorProps" #append>
      <v-icon class="opacity-100" :icon="isOpen ? mdiChevronUp : mdiChevronDown" />
    </template>
    <template v-else-if="appendIcon" #append>
      <v-icon class="opacity-100" :icon="appendIcon" size="small" />
    </template>
  </v-list-item>
</template>

<script lang="ts" setup>
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import { type RouteRecordRaw } from 'vue-router';

import { injectAppNavigationOrThrow } from './AppNavigation.context';

interface Props {
  activatorProps?: Record<string, any>;
  appendIcon?: string;
  icon?: string;
  isOpen?: boolean;
  route: RouteRecordRaw;
}

const { route } = defineProps<Props>();

const appNavigation = injectAppNavigationOrThrow();

const isRoutePermitted = appNavigation.isRoutePermitted(() => route.meta);
</script>

<style lang="scss" scoped>
:deep(.v-list-item__prepend){
  .v-list-item__spacer{
    width: 1rem !important;
  }
}

.icon {
  margin-right: 2px;
}

:deep(.v-list-item-title) {
  font-size: 0.875rem !important;
  font-weight: 400 !important;
  line-height: 1.05rem !important;
}
</style>
